import { useMutation } from '@tanstack/react-query';
import { IImpersonationContext, IOperationResultNoValue, ImpersonationBroker } from '../../extViewmodels';
import { WebsiteContent } from '../../extViewmodels/sdk/models/Website';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useEditWebsiteContentParentMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (data: WebsiteContent) => void;
	onError?: (error: IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: (params: {
			id: string;
			contentId: string;
			parentContentId: string;
			impersonationContext?: IImpersonationContext;
		}) => {
			return userSession.webServiceHelper.callAsync<WebsiteContent>(
				ImpersonationBroker.composeApiUrl({
					urlPath: `website/${params.id}/content/${params.contentId}/parentWebsiteContentId`,
					impersonationContext: params.impersonationContext,
				}),
				'PUT',
				params.parentContentId
			);
		},
		onError,
		onSuccess,
	});
}
